import { AuditReportsGipReportScheduleDto } from '@mi-front/api-v2';
import { MrtTable } from '@mi-front/ui';
import { MRT_ColumnDef } from 'material-react-table';
import { useGipResultColumnsFactory } from './useGipResultColumnsFactory';

interface Props {
  schedules: AuditReportsGipReportScheduleDto[];
}

export const GipReportUnprocessedSchedulesView = ({ schedules: unprocessedSchedules }: Props) => {
  const columns = useGipResultColumnsFactory();

  const tableColumns = [
    columns.station,
    columns.dateTime,
    columns.materialStatus,
    columns.advertiser,
    columns.campaign,
    columns.version,
    columns.contract,
    columns.order,
  ] as unknown as MRT_ColumnDef<AuditReportsGipReportScheduleDto>[];

  return (
    <MrtTable<AuditReportsGipReportScheduleDto>
      data={unprocessedSchedules}
      columns={tableColumns}
      muiTableBodyRowProps={({ row }) => {
        const { audioId } = row.original;
        const isMissing = !audioId;

        return {
          sx: {
            backgroundColor: isMissing ? 'rgba(255, 152, 0, 0.1) !important' : 'inherit',
            '&:hover': {
              backgroundColor: isMissing ? 'rgba(255, 152, 0, 0.2) !important' : 'inherit',
            },
          },
        };
      }}
    />
  );
};
